'use client';

import { useState, type ComponentPropsWithoutRef } from 'react';
import { CloudWarningIcon } from '@phosphor-icons/react';
import { getStatusIcon } from './clientFunctions';

export type ProvenanceIconProps = {
  status: string | undefined;
  size?: number;
  className?: string;
} & Omit<ComponentPropsWithoutRef<'div'>, 'children'>;

export const ProvenanceIcon = ({
  status,
  size = 20,
  className = '',
  ...divProps
}: ProvenanceIconProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const renderUnknownStatusIcon = () => (
    <div
      className="flex items-center justify-center"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...divProps}
    >
      <CloudWarningIcon
        size={size}
        weight={isHovered ? 'fill' : 'regular'}
        className={className}
      />
    </div>
  );

  try {
    const IconComponent = getStatusIcon(status);
    if (!IconComponent) {
      return renderUnknownStatusIcon();
    }

    return (
      <div
        className="flex items-center justify-center"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        {...divProps}
      >
        <IconComponent size={size} weight={isHovered ? 'fill' : 'regular'} className={className} />
      </div>
    );
  } catch {
    return (
      <div
        className="flex items-center justify-center"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        {...divProps}
      >
        <CloudWarningIcon size={size} weight={isHovered ? 'fill' : 'regular'} className={className} />
      </div>
    );
  }
};
